import React from "react";
import NewAuth from "./NewAuth";

export default function Signup(props) {
  return <NewAuth isSignup={true} {...props} />;
}
